// assets/accessibility.js
// Perfect Locks Accessibility Script
// Includes: Live Region Manager, Cart/Variant Announcers, Media Accessibility,
// Klaviyo Fixes, Tracking Pixel Fixes, and Shared DOM Observer

(function() {
  'use strict';

  // ============================================
  // LIVE REGION MANAGER - VoiceOver Compatible
  // ============================================
  var LiveRegionManager = {
    init: function() {
      if (!document.getElementById('accessibility-announcer-1')) {
        var region1 = document.createElement('div');
        region1.id = 'accessibility-announcer-1';
        region1.setAttribute('role', 'status');
        region1.setAttribute('aria-live', 'assertive');
        region1.setAttribute('aria-atomic', 'true');
        region1.className = 'sr-only';
        document.body.insertBefore(region1, document.body.firstChild);

        var region2 = document.createElement('div');
        region2.id = 'accessibility-announcer-2';
        region2.setAttribute('role', 'status');
        region2.setAttribute('aria-live', 'assertive');
        region2.setAttribute('aria-atomic', 'true');
        region2.className = 'sr-only';
        document.body.insertBefore(region2, document.body.firstChild);
      }
      this.currentRegion = 1;
    },

    announce: function(message) {
      if (!document.getElementById('accessibility-announcer-1')) this.init();

      var region1 = document.getElementById('accessibility-announcer-1');
      var region2 = document.getElementById('accessibility-announcer-2');

      region1.textContent = '';
      region2.textContent = '';

      var self = this;
      setTimeout(function() {
        if (self.currentRegion === 1) {
          region1.textContent = message;
          self.currentRegion = 2;
        } else {
          region2.textContent = message;
          self.currentRegion = 1;
        }
      }, 50);
    }
  };

  // ============================================
  // CART ANNOUNCEMENTS - INTERCEPT FETCH
  // ============================================
  var CartAnnouncer = {
    triggerButton: null,
    lastCartCount: null,
    pendingRemoval: false,
    pendingQuantityChange: false,
    isDrawerOpen: false,
    addedViaButton: false,

    init: function() {
      var self = this;

      // Intercept fetch - only clone cart-related responses
      var originalFetch = window.fetch;
      window.fetch = function(url, options) {
        var urlString = url.toString();
        var isCartRequest = urlString.indexOf('/cart/') > -1;

        return originalFetch.apply(this, arguments).then(function(response) {
          if (!isCartRequest) return response;

          var clonedResponse = response.clone();

          if (urlString.indexOf('/cart/add') > -1) {
            clonedResponse.json().then(function(data) {
              self.onAddToCartSuccess(data);
            }).catch(function() {});
          }

          if (urlString.indexOf('/cart/change') > -1 || urlString.indexOf('/cart/update') > -1) {
            clonedResponse.json().then(function(data) {
              self.onCartChange(data);
            }).catch(function() {});
          }

          if (urlString.indexOf('/cart/clear') > -1) {
            setTimeout(function() {
              LiveRegionManager.announce('Cart cleared');
            }, 500);
          }

          return response;
        });
      };

      // Track trigger button
      document.addEventListener('click', function(event) {
        var button = event.target.closest('#AddToCart, [data-product-add-to-cart-button]');
        if (button) {
          self.triggerButton = button;
          self.addedViaButton = true;
        }

        var removeButton = event.target.closest('[data-action="remove"], .cart-item__remove, [href*="/cart/change"]');
        if (removeButton) {
          self.pendingRemoval = true;
        }

        var quantityButton = event.target.closest('.quantity-selector__button, [data-action="decrease"], [data-action="increase"]');
        if (quantityButton) {
          self.pendingQuantityChange = true;
        }
      });

      this.getCartCount();
      this.setupCartDrawerFocus();
      this.fixCartIconAccessibility();
    },

    fixCartIconAccessibility: function() {
      var cartBadges = document.querySelectorAll('.cart-count, [data-cart-count], .header__cart-count');
      cartBadges.forEach(function(badge) {
        badge.setAttribute('aria-hidden', 'true');
      });

      var cartLinks = document.querySelectorAll('a[href="/cart"], a[href="/cart/"], [data-action="open-cart"]');
      cartLinks.forEach(function(link) {
        if (!link.getAttribute('aria-label')) {
          link.setAttribute('aria-label', 'Open cart');
        }
      });
    },

    getCartCount: function() {
      var countEl = document.querySelector('[data-cart-count], .cart-count');
      if (countEl) {
        this.lastCartCount = parseInt(countEl.textContent) || 0;
      }
    },

    onAddToCartSuccess: function(data) {
      var self = this;
      var productTitle = 'Item';
      var quantity = 1;

      if (data) {
        productTitle = data.title || data.product_title || 'Item';
        quantity = data.quantity || 1;
      }

      if (productTitle === 'Item') {
        var titleEl = document.querySelector('.product-info__title, .product-title, h1.title');
        if (titleEl) {
          productTitle = titleEl.textContent.trim();
        }
      }

      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          var cartCount = cart.item_count || 1;
          self.lastCartCount = cartCount;

          var message = quantity > 1
            ? quantity + ' ' + productTitle + ' added to cart'
            : productTitle + ' added to cart';

          message += '. Cart has ' + cartCount + ' ' + (cartCount === 1 ? 'item' : 'items');

          setTimeout(function() {
            LiveRegionManager.announce(message);
          }, 300);
        })
        .catch(function() {
          var message = quantity > 1
            ? quantity + ' ' + productTitle + ' added to cart'
            : productTitle + ' added to cart';

          setTimeout(function() {
            LiveRegionManager.announce(message);
          }, 300);
        });
    },

    onCartChange: function(data) {
      var self = this;

      if (!data) return;

      var newCount = data.item_count || 0;
      var oldCount = this.lastCartCount || 0;

      setTimeout(function() {
        if (newCount === 0) {
          LiveRegionManager.announce('Your cart is now empty');
        } else if (self.pendingRemoval && newCount < oldCount) {
          LiveRegionManager.announce('Item removed from cart. ' + newCount + ' ' + (newCount === 1 ? 'item' : 'items') + ' remaining');
          self.pendingRemoval = false;
        } else if (self.pendingQuantityChange) {
          LiveRegionManager.announce('Cart updated. ' + newCount + ' ' + (newCount === 1 ? 'item' : 'items') + ' in cart');
          self.pendingQuantityChange = false;
        }

        self.lastCartCount = newCount;
      }, 800);
    },

    setupCartDrawerFocus: function() {
      var self = this;
      var cartDrawer = document.getElementById('mini-cart');

      if (!cartDrawer) return;

      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open') {
            if (cartDrawer.hasAttribute('open')) {
              self.isDrawerOpen = true;
              self.onDrawerOpen(cartDrawer);
            } else {
              self.isDrawerOpen = false;
              self.onDrawerClose();
            }
          }
        });
      });

      observer.observe(cartDrawer, { attributes: true });
    },

    onDrawerOpen: function(drawer) {
      var self = this;

      if (this.addedViaButton) {
        this.lastTrigger = this.triggerButton;
        this.triggerButton = null;
        this.addedViaButton = false;
        return;
      }

      this.lastTrigger = document.activeElement;

      setTimeout(function() {
        if (!self.isDrawerOpen) return;

        var cartHeading = drawer.querySelector('h2, .drawer__title, .cart-drawer__title');
        if (cartHeading) {
          cartHeading.setAttribute('tabindex', '-1');
          cartHeading.focus();
          return;
        }

        var closeButton = drawer.querySelector('[data-action="close"], .drawer__close-button');
        if (closeButton) {
          closeButton.focus();
        }
      }, 300);
    },

    onDrawerClose: function() {
      var self = this;

      setTimeout(function() {
        if (self.lastTrigger && document.body.contains(self.lastTrigger)) {
          var isCartIcon = self.lastTrigger.closest('[data-action="open-cart"], a[href*="/cart"]');

          if (isCartIcon) {
            var mainContent = document.getElementById('main') || document.querySelector('main');
            if (mainContent) {
              mainContent.setAttribute('tabindex', '-1');
              mainContent.focus();
              mainContent.removeAttribute('tabindex');
            }
          } else {
            self.lastTrigger.focus();
          }

          self.lastTrigger = null;
        }
      }, 100);
    }
  };

  // ============================================
  // VARIANT ANNOUNCEMENTS
  // ============================================
  var VariantAnnouncer = {
    lastPrice: null,
    lastInventory: null,
    pendingAnnouncement: null,
    themeObserver: null,

    init: function() {
      var self = this;

      this.disableThemeAriaLive();
      this.watchForThemeAriaLive();

      setTimeout(function() {
        self.lastPrice = self.getCurrentPrice();
        self.lastInventory = self.getInventoryStatus();
      }, 500);

      document.addEventListener('change', function(event) {
        var target = event.target;

        if (target.type === 'radio' && target.closest('.variant-picker, .product-form__option')) {
          if (self.pendingAnnouncement) {
            clearTimeout(self.pendingAnnouncement);
          }

          self.pendingAnnouncement = setTimeout(function() {
            self.announceChanges();
          }, 600);
        }
      });

      document.addEventListener('click', function(event) {
        var swatch = event.target.closest('.color-swatch__item, .block-swatch__item');

        if (swatch) {
          if (self.pendingAnnouncement) {
            clearTimeout(self.pendingAnnouncement);
          }

          self.pendingAnnouncement = setTimeout(function() {
            self.announceChanges();
          }, 600);
        }
      });
    },

    disableThemeAriaLive: function() {
      var productInfo = document.querySelector('.product-info, .product__info-wrapper, [data-product-info]');
      if (productInfo) {
        var liveRegions = productInfo.querySelectorAll('[aria-live], [role="status"]');
        liveRegions.forEach(function(el) {
          if (el.id && el.id.indexOf('accessibility-announcer') > -1) return;

          el.removeAttribute('aria-live');
          el.removeAttribute('aria-atomic');
          el.removeAttribute('role');
        });
      }

      var focalElements = document.querySelectorAll('sale-price, product-inventory, compare-at-price');
      focalElements.forEach(function(el) {
        el.removeAttribute('aria-live');
        el.removeAttribute('aria-atomic');
        el.removeAttribute('role');

        var parent = el.parentElement;
        if (parent) {
          parent.removeAttribute('aria-live');
          parent.removeAttribute('aria-atomic');
        }
      });
    },

    watchForThemeAriaLive: function() {
      var self = this;

      this.themeObserver = new MutationObserver(function(mutations) {
        var needsCleanup = false;

        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes') {
            var attr = mutation.attributeName;
            if (attr === 'aria-live' || attr === 'aria-atomic' || attr === 'role') {
              var target = mutation.target;
              if (target.id && target.id.indexOf('accessibility-announcer') > -1) return;
              needsCleanup = true;
            }
          }

          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            needsCleanup = true;
          }
        });

        if (needsCleanup) {
          setTimeout(function() {
            self.disableThemeAriaLive();
          }, 50);
        }
      });

      var productInfo = document.querySelector('.product-info, .product__info-wrapper, main');
      if (productInfo) {
        this.themeObserver.observe(productInfo, {
          attributes: true,
          attributeFilter: ['aria-live', 'aria-atomic', 'role'],
          childList: true,
          subtree: true
        });
      }
    },

    announceChanges: function() {
      var messages = [];

      var newPrice = this.getCurrentPrice();
      if (newPrice && newPrice !== this.lastPrice) {
        messages.push(newPrice);
        this.lastPrice = newPrice;
      }

      var newInventory = this.getInventoryStatus();
      if (newInventory !== this.lastInventory) {
        if (newInventory) {
          messages.push(newInventory);
        }
        this.lastInventory = newInventory;
      }

      if (messages.length > 0) {
        LiveRegionManager.announce(messages.join('. '));
      }
    },

    getInventoryStatus: function() {
      var addButton = document.querySelector('[data-product-add-to-cart-button], #AddToCart, .product-form__submit');
      if (addButton) {
        var buttonText = addButton.textContent.toLowerCase().trim();
        if (addButton.disabled || buttonText.indexOf('sold out') > -1 || buttonText.indexOf('unavailable') > -1) {
          return 'Sold out';
        }
      }

      var lowStockEl = document.querySelector('.inventory--low');
      if (lowStockEl) {
        var text = lowStockEl.textContent.trim();
        if (text && text.toLowerCase().indexOf('only') > -1) {
          return text;
        }
      }

      return null;
    },

    getCurrentPrice: function() {
      var salePrice = document.querySelector('sale-price');
      if (salePrice) {
        var text = salePrice.textContent;
        var match = text.match(/\$[\d,]+(?:\.\d{2})?/);
        if (match) {
          return match[0];
        }
      }

      var priceEl = document.querySelector('.price .money, [data-product-price], .product-info__price .money');
      if (priceEl) {
        var match = priceEl.textContent.match(/\$[\d,]+(?:\.\d{2})?/);
        if (match) {
          return match[0];
        }
      }

      return null;
    }
  };

  // ============================================
  // PRODUCT MEDIA GALLERY ACCESSIBILITY
  // ============================================
  var ProductMediaAccessibility = {
    init: function() {
      this.initCarouselAnnouncements();
      this.initThumbnailNavigation();
      this.initDotNavigation();
      this.initProgressBarAccessibility();
    },

    initCarouselAnnouncements: function() {
      var self = this;
      var carousels = document.querySelectorAll('flickity-carousel');

      carousels.forEach(function(carousel) {
        carousel.addEventListener('settle', function() {
          self.handleSlideChange(carousel);
        });

        carousel.addEventListener('keydown', function(event) {
          self.handleCarouselKeydown(event, carousel);
        });

        if (!carousel.hasAttribute('tabindex')) {
          carousel.setAttribute('tabindex', '0');
        }
      });
    },

    handleSlideChange: function(carousel) {
      var selectedSlide = carousel.querySelector('.is-selected');
      if (!selectedSlide) return;

      var allSlides = carousel.querySelectorAll('.product__media-item:not(.is-filtered)');
      var slideIndex = Array.from(allSlides).indexOf(selectedSlide) + 1;
      var totalSlides = allSlides.length;

      if (slideIndex > 0 && totalSlides > 0) {
        carousel.querySelectorAll('.product__media-item').forEach(function(slide) {
          var isSelected = slide === selectedSlide;
          slide.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });

        var slideLabel = selectedSlide.getAttribute('aria-label');
        var announcement = slideLabel || ('Image ' + slideIndex + ' of ' + totalSlides);

        setTimeout(function() {
          LiveRegionManager.announce(announcement);
        }, 100);
      }
    },

    getFlickityInstance: function(element) {
      if (window.ThemeFlickity && typeof window.ThemeFlickity.data === 'function') {
        var instance = window.ThemeFlickity.data(element);
        if (instance) return instance;

        var flickityEl = element.classList.contains('flickity-enabled')
          ? element
          : element.querySelector('.flickity-enabled');

        if (flickityEl) {
          return window.ThemeFlickity.data(flickityEl);
        }
      }
      return null;
    },

    handleCarouselKeydown: function(event, carousel) {
      var key = event.key;
      var flickityControls = document.querySelector('[controls="' + carousel.id + '"]');
      var flickityInstance = this.getFlickityInstance(carousel);

      if (key === 'ArrowLeft' || key === 'ArrowUp') {
        event.preventDefault();
        var prevButton = flickityControls ? flickityControls.querySelector('[data-action="prev"]') : null;
        if (prevButton) {
          prevButton.click();
        } else if (flickityInstance) {
          flickityInstance.previous();
        }
      } else if (key === 'ArrowRight' || key === 'ArrowDown') {
        event.preventDefault();
        var nextButton = flickityControls ? flickityControls.querySelector('[data-action="next"]') : null;
        if (nextButton) {
          nextButton.click();
        } else if (flickityInstance) {
          flickityInstance.next();
        }
      } else if (key === 'Home') {
        event.preventDefault();
        if (flickityInstance) {
          flickityInstance.select(0);
        }
      } else if (key === 'End') {
        event.preventDefault();
        var slides = carousel.querySelectorAll('.product__media-item:not(.is-filtered)');
        if (slides.length && flickityInstance) {
          flickityInstance.select(slides.length - 1);
        }
      }
    },

    initThumbnailNavigation: function() {
      var thumbnailLists = document.querySelectorAll('.product__thumbnail-list');

      thumbnailLists.forEach(function(list) {
        var buttons = Array.from(list.querySelectorAll('.product__thumbnail-item:not(.is-filtered)'));
        if (buttons.length === 0) return;

        buttons.forEach(function(button, index) {
          var isSelected = button.getAttribute('aria-current') === 'true' ||
                          button.getAttribute('aria-selected') === 'true';
          button.setAttribute('tabindex', isSelected ? '0' : '-1');

          if (index === 0 && !list.querySelector('[tabindex="0"]')) {
            button.setAttribute('tabindex', '0');
          }
        });

        buttons.forEach(function(button, index) {
          button.addEventListener('keydown', function(event) {
            ProductMediaAccessibility.handleThumbnailKeydown(event, buttons, index);
          });

          button.addEventListener('click', function() {
            ProductMediaAccessibility.updateThumbnailSelection(buttons, button);
          });
        });
      });
    },

    handleThumbnailKeydown: function(event, buttons, currentIndex) {
      var key = event.key;
      var targetIndex = currentIndex;

      if (key === 'ArrowRight' || key === 'ArrowDown') {
        event.preventDefault();
        targetIndex = (currentIndex + 1) % buttons.length;
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        event.preventDefault();
        targetIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      } else if (key === 'Home') {
        event.preventDefault();
        targetIndex = 0;
      } else if (key === 'End') {
        event.preventDefault();
        targetIndex = buttons.length - 1;
      } else if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        buttons[currentIndex].click();
        return;
      } else {
        return;
      }

      buttons.forEach(function(btn, i) {
        btn.setAttribute('tabindex', i === targetIndex ? '0' : '-1');
      });
      buttons[targetIndex].focus();
    },

    updateThumbnailSelection: function(buttons, selectedButton) {
      buttons.forEach(function(btn) {
        var isSelected = btn === selectedButton;
        btn.setAttribute('tabindex', isSelected ? '0' : '-1');
        btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        if (isSelected) {
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.removeAttribute('aria-current');
        }
      });
    },

    initDotNavigation: function() {
      var dotNavs = document.querySelectorAll('.dots-nav');

      dotNavs.forEach(function(nav) {
        var dots = Array.from(nav.querySelectorAll('.dots-nav__item:not(.is-filtered)'));
        if (dots.length === 0) return;

        dots.forEach(function(dot, index) {
          var isSelected = dot.getAttribute('aria-current') === 'true' ||
                          dot.getAttribute('aria-selected') === 'true';
          dot.setAttribute('tabindex', isSelected ? '0' : '-1');

          if (index === 0 && !nav.querySelector('[tabindex="0"]')) {
            dot.setAttribute('tabindex', '0');
          }
        });

        dots.forEach(function(dot, index) {
          dot.addEventListener('keydown', function(event) {
            ProductMediaAccessibility.handleDotKeydown(event, dots, index);
          });

          dot.addEventListener('click', function() {
            ProductMediaAccessibility.updateDotSelection(dots, dot);
          });
        });
      });
    },

    handleDotKeydown: function(event, dots, currentIndex) {
      var key = event.key;
      var targetIndex = currentIndex;

      if (key === 'ArrowRight' || key === 'ArrowDown') {
        event.preventDefault();
        targetIndex = (currentIndex + 1) % dots.length;
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        event.preventDefault();
        targetIndex = (currentIndex - 1 + dots.length) % dots.length;
      } else if (key === 'Home') {
        event.preventDefault();
        targetIndex = 0;
      } else if (key === 'End') {
        event.preventDefault();
        targetIndex = dots.length - 1;
      } else if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        dots[currentIndex].click();
        return;
      } else {
        return;
      }

      dots.forEach(function(d, i) {
        d.setAttribute('tabindex', i === targetIndex ? '0' : '-1');
      });
      dots[targetIndex].focus();
    },

    updateDotSelection: function(dots, selectedDot) {
      dots.forEach(function(d) {
        var isSelected = d === selectedDot;
        d.setAttribute('tabindex', isSelected ? '0' : '-1');
        d.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        if (isSelected) {
          d.setAttribute('aria-current', 'true');
        } else {
          d.removeAttribute('aria-current');
        }
      });
    },

    initProgressBarAccessibility: function() {
      var progressBars = document.querySelectorAll('.slider-progress-bar-container');

      progressBars.forEach(function(container) {
        if (!container.hasAttribute('role')) {
          container.setAttribute('role', 'progressbar');
          container.setAttribute('aria-valuenow', '0');
          container.setAttribute('aria-valuemin', '0');
          container.setAttribute('aria-valuemax', '100');
          container.setAttribute('aria-label', 'Gallery scroll progress');
        }

        var progressBar = container.querySelector('.slider-progress-bar');
        if (!progressBar) return;

        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              var width = progressBar.style.width;
              if (width) {
                var value = parseFloat(width);
                container.setAttribute('aria-valuenow', Math.round(value));
              }
            }
          });
        });

        observer.observe(progressBar, { attributes: true, attributeFilter: ['style'] });
      });
    }
  };

  // ============================================
  // KLAVIYO FORM ACCESSIBILITY FIXES
  // WCAG 2.1 A 1.3.1 (Info and Relationships)
  // WCAG 2.1 A 4.1.2 (Name, Role, Value)
  // ============================================
  var KlaviyoAccessibility = {
    init: function() {
      if (document.querySelector('[class*="klaviyo-form"]')) {
        this.fixKlaviyoDropdowns();
      }

      // Initial load fix
      window.addEventListener('load', function() {
        setTimeout(function() {
          KlaviyoAccessibility.fixKlaviyoDropdowns();
        }, 500);
      });
    },

    // Called by SharedObserver when Klaviyo forms are detected
    onDynamicContent: function() {
      this.fixKlaviyoDropdowns();
    },

    fixKlaviyoDropdowns: function() {
      var self = this;
      var klaviyoForms = document.querySelectorAll('[class*="klaviyo-form"]');

      klaviyoForms.forEach(function(form) {
        self.fixMissingLabels(form);
        self.fixEmptyListboxes(form);
        self.observeListboxChanges(form);
      });
    },

    fixMissingLabels: function(form) {
      var comboboxInputs = form.querySelectorAll('input[role="combobox"][aria-labelledby]');

      comboboxInputs.forEach(function(input) {
        var labelId = input.getAttribute('aria-labelledby');

        if (labelId && !document.getElementById(labelId)) {
          var labelText = input.getAttribute('aria-label') ||
                          input.getAttribute('placeholder') ||
                          'Select an option';

          var label = document.createElement('span');
          label.id = labelId;
          label.className = 'sr-only';
          label.textContent = labelText;

          var container = input.closest('[data-testid="form-component"]') || input.parentElement;
          if (container) {
            container.insertBefore(label, container.firstChild);
          }
        }
      });

      var listboxes = form.querySelectorAll('[role="listbox"][aria-labelledby]');

      listboxes.forEach(function(listbox) {
        var labelId = listbox.getAttribute('aria-labelledby');

        if (labelId && !document.getElementById(labelId)) {
          var associatedInput = form.querySelector('input[aria-controls="' + listbox.id + '"]');

          if (associatedInput) {
            var labelText = associatedInput.getAttribute('aria-label') ||
                            associatedInput.getAttribute('placeholder') ||
                            'Options';

            var label = document.createElement('span');
            label.id = labelId;
            label.className = 'sr-only';
            label.textContent = labelText;

            listbox.parentElement.insertBefore(label, listbox);
          }
        }
      });
    },

    fixEmptyListboxes: function(form) {
      var listboxes = form.querySelectorAll('[role="listbox"], [data-original-role="listbox"]');

      listboxes.forEach(function(listbox) {
        var options = listbox.querySelectorAll('[role="option"]');

        if (options.length === 0 && listbox.hasAttribute('role')) {
          listbox.setAttribute('data-original-role', 'listbox');
          listbox.removeAttribute('role');
        }
      });
    },

    observeListboxChanges: function(form) {
      var listboxes = form.querySelectorAll('[role="listbox"], [data-original-role="listbox"]');

      listboxes.forEach(function(listbox) {
        if (listbox.hasAttribute('data-a11y-mutation-observed')) {
          return;
        }

        listbox.setAttribute('data-a11y-mutation-observed', 'true');

        var observer = new MutationObserver(function() {
          var options = listbox.querySelectorAll('[role="option"]');

          if (options.length > 0) {
            if (listbox.hasAttribute('data-original-role')) {
              listbox.setAttribute('role', 'listbox');
            }

            options.forEach(function(option, index) {
              if (!option.hasAttribute('tabindex')) {
                option.setAttribute('tabindex', '-1');
              }
              if (!option.id) {
                option.id = listbox.id + '-option-' + index;
              }
            });
          } else {
            if (listbox.hasAttribute('role')) {
              listbox.setAttribute('data-original-role', 'listbox');
              listbox.removeAttribute('role');
            }
          }
        });

        observer.observe(listbox, {
          childList: true,
          subtree: true
        });
      });
    }
  };

  // ============================================
  // TRACKING PIXEL ACCESSIBILITY FIXES
  // WCAG 2.1 A 1.1.1 (Non-text Content)
  // ============================================
  var TrackingPixelAccessibility = {
    init: function() {
      this.fixTrackingPixels();

      setTimeout(function() {
        TrackingPixelAccessibility.fixTrackingPixels();
      }, 2000);
    },

    // Called by SharedObserver when images are added
    onDynamicContent: function() {
      this.fixTrackingPixels();
    },

    fixTrackingPixels: function() {
      var trackingPixels = document.querySelectorAll(
        'img[src*="trkn.us"], ' +
        'img[src*="facebook.com/tr"], ' +
        'img[src*="analytics"], ' +
        'img[src*="pixel"], ' +
        'img[src*="beacon"], ' +
        'img[id^="_pxPixel"], ' +
        'img[width="1"][height="1"], ' +
        'img[src$=".gif"][width="1"], ' +
        'img[src$=".gif"][height="1"]'
      );

      trackingPixels.forEach(function(img) {
        if (!img.hasAttribute('alt')) {
          img.setAttribute('alt', '');
          img.setAttribute('role', 'presentation');
          img.setAttribute('aria-hidden', 'true');
        }
      });
    }
  };

  // ============================================
  // SHARED DOM OBSERVER
  // Single MutationObserver replacing 4 separate ones.
  // Dispatches to modules based on what was added.
  // ============================================
  var SharedObserver = {
    timeout: null,
    pendingKlaviyo: false,
    pendingTracking: false,

    init: function() {
      var self = this;

      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length === 0) return;

          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType !== Node.ELEMENT_NODE) return;

            // Check for Klaviyo forms
            if (node.classList &&
                (node.classList.contains('klaviyo-form') ||
                 (node.querySelector && node.querySelector('[class*="klaviyo-form"]')))) {
              self.pendingKlaviyo = true;
            }

            // Check for tracking pixels (img elements)
            if (node.tagName === 'IMG' || (node.querySelector && node.querySelector('img'))) {
              self.pendingTracking = true;
            }
          });
        });

        if (self.pendingKlaviyo || self.pendingTracking) {
          clearTimeout(self.timeout);
          self.timeout = setTimeout(function() {
            if (self.pendingKlaviyo) {
              KlaviyoAccessibility.onDynamicContent();
              self.pendingKlaviyo = false;
            }
            if (self.pendingTracking) {
              TrackingPixelAccessibility.onDynamicContent();
              self.pendingTracking = false;
            }
          }, 150);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  // ============================================
  // THEME BUG FIXES
  // ============================================
  function patchThemeBugs() {
    customElements.whenDefined('product-media').then(function() {
      var ProductMediaClass = customElements.get('product-media');
      if (ProductMediaClass && ProductMediaClass.prototype._onFlickityChanged) {
        var originalMethod = ProductMediaClass.prototype._onFlickityChanged;
        ProductMediaClass.prototype._onFlickityChanged = async function() {
          try {
            const flickityInstance = await this.mainCarousel.flickityInstance;
            flickityInstance.cells.forEach(function(item) {
              if (['external_video', 'video', 'model'].includes(item.element.getAttribute('data-media-type'))) {
                var firstChild = item.element.firstElementChild;
                if (firstChild && typeof firstChild.pause === 'function') {
                  firstChild.pause();
                }
                var video = item.element.querySelector('video');
                if (video && typeof video.pause === 'function') {
                  video.pause();
                }
              }
            });
          } catch (e) {
            // Silently handle errors
          }
        };
      }
    }).catch(function() {});
  }

  // ============================================
  // INIT
  // ============================================
  function init() {
    patchThemeBugs();
    LiveRegionManager.init();
    CartAnnouncer.init();
    VariantAnnouncer.init();
    ProductMediaAccessibility.init();
    KlaviyoAccessibility.init();
    TrackingPixelAccessibility.init();
    SharedObserver.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when Shopify sections are reloaded (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    ProductMediaAccessibility.init();
    KlaviyoAccessibility.init();
    TrackingPixelAccessibility.init();
  });

  window.AccessibilityAnnouncer = {
    LiveRegionManager: LiveRegionManager,
    CartAnnouncer: CartAnnouncer,
    VariantAnnouncer: VariantAnnouncer,
    ProductMediaAccessibility: ProductMediaAccessibility,
    KlaviyoAccessibility: KlaviyoAccessibility,
    TrackingPixelAccessibility: TrackingPixelAccessibility
  };

})();